module.exports = __webpack_public_path__ + "static/media/rachana_gade.b15ecfad.jpg";